<template>
  <div>
    <Breadcrumb v-if="!$route.meta.isBreadcrumb"></Breadcrumb>
    <div class="content-wrap">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import Breadcrumb from 'components/Breadcrumb'

export default {
  components: { Breadcrumb },
}
</script>

<style lang="less" scoped>
.content-wrap {
  margin: 24px 24px 50px;
}
</style>
